<div class="page-layout">
  <!-- Sidebar -->
  <app-sidebar></app-sidebar>

  <!-- Main Content -->
  <main class="main-content">
    <!-- Page Header -->
    <header class="page-header">
      <h1 class="page-title">Trainers</h1>
      <button class="btn btn-primary" (click)="openCreateModal()">
        <svg viewBox="0 0 24 24" class="btn-icon">
          <path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
        </svg>
        Add trainer
      </button>
    </header>

    <!-- Content Card -->
    <div class="content-card">
      <!-- Table Header -->
      <div class="table-header">
        <div class="table-title-section">
          <h2 class="table-title">Trainers list</h2>
          <span class="badge badge-blue">{{trainers.length}}</span>
        </div>
        <div class="search-box">
          <svg viewBox="0 0 24 24" class="search-icon">
            <path fill="currentColor" d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
          </svg>
          <input
            type="text"
            placeholder="Search"
            class="search-input"
            [(ngModel)]="searchQuery"
            (input)="onSearch()"
          />
        </div>
      </div>

      <!-- Table -->
      <div class="table-container">
        <table class="data-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Phone</th>
              <th>Status</th>
              <th>Joined</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="isLoading">
              <td colspan="5" style="text-align: center; padding: 2rem;">
                Loading trainers...
              </td>
            </tr>
            <tr *ngIf="!isLoading && paginatedTrainers.length === 0">
              <td colspan="5" style="text-align: center; padding: 2rem;">
                No trainers found.
              </td>
            </tr>
            <tr *ngFor="let trainer of paginatedTrainers" class="table-row">
              <td>
                <div class="trainer-info">
                  <div class="trainer-avatar">
                    <img [src]="getAvatar(trainer.name)" [alt]="trainer.name"/>
                  </div>
                  <div class="trainer-details">
                    <div class="trainer-name">{{trainer.name}}</div>
                    <div class="trainer-email" *ngIf="trainer.email">{{trainer.email}}</div>
                  </div>
                </div>
              </td>
              <td>
                <span class="phone-text">{{trainer.phoneNumber}}</span>
              </td>
              <td>
                <span class="level-badge" [class.verified]="trainer.isPhoneVerified" [class.unverified]="!trainer.isPhoneVerified">
                  {{trainer.isPhoneVerified ? 'Verified' : 'Unverified'}}
                </span>
              </td>
              <td>
                <span class="salary-text">{{trainer.createdAt | date: 'MMM d, y'}}</span>
              </td>
              <td>
                <div class="action-buttons">
                  <button class="action-btn" title="Delete">
                    <svg viewBox="0 0 24 24">
                      <path fill="currentColor" d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
                    </svg>
                  </button>
                  <button class="action-btn" title="Edit">
                    <svg viewBox="0 0 24 24">
                      <path fill="currentColor" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="pagination-container" *ngIf="totalPages > 1">
        <button
          class="pagination-btn"
          (click)="previousPage()"
          [disabled]="currentPage === 1"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
          Previous
        </button>

        <div class="pagination-pages">
          <ng-container *ngFor="let page of getPageNumbers()">
            <button
              *ngIf="page !== '...'"
              class="pagination-page"
              [class.active]="page === currentPage"
              (click)="goToPage($any(page))"
            >
              {{ page }}
            </button>
            <span *ngIf="page === '...'" class="pagination-ellipsis">...</span>
          </ng-container>
        </div>

        <button
          class="pagination-btn"
          (click)="nextPage()"
          [disabled]="currentPage === totalPages"
        >
          Next
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>
      </div>
    </div>
  </main>
</div>

<!-- Create Coach Modal -->
<div class="modal-overlay" *ngIf="showCreateModal" (click)="closeCreateModal()">
  <div class="modal-panel" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">Add Trainer</h2>
      <button class="modal-close" (click)="closeCreateModal()">
        <svg viewBox="0 0 24 24" width="20" height="20">
          <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      </button>
    </div>

    <div class="modal-body">
      <div class="form-group">
        <label class="form-label">Name *</label>
        <input
          type="text"
          class="form-input"
          placeholder="Enter trainer name"
          [(ngModel)]="newCoach.name"
        />
      </div>

      <div class="form-group">
        <label class="form-label">Phone Number *</label>
        <input
          type="tel"
          class="form-input"
          placeholder="e.g. 05xxxxxxxx"
          [(ngModel)]="newCoach.phoneNumber"
        />
      </div>

      <div class="form-group">
        <label class="form-label">Password *</label>
        <input
          type="password"
          class="form-input"
          placeholder="Enter password"
          [(ngModel)]="newCoach.password"
        />
      </div>

      <div class="form-group">
        <label class="form-label">Email</label>
        <input
          type="email"
          class="form-input"
          placeholder="Enter email (optional)"
          [(ngModel)]="newCoach.email"
        />
      </div>

      <div class="form-error" *ngIf="createError">{{createError}}</div>
    </div>

    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closeCreateModal()" [disabled]="isCreating">Cancel</button>
      <button class="btn btn-primary" (click)="submitCreateCoach()" [disabled]="isCreating">
        {{isCreating ? 'Creating...' : 'Create Trainer'}}
      </button>
    </div>
  </div>
</div>
